import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('AdditionalRow2', 'Steps', {
	data() {
		return {
			additional: null,
			visabilityInner: false,
			selectedPanelModel: null,
			selectedPanelColor: null,
			selectedPanelTorce: 0,
			selectedPanelDocking: 0,
			torceCount: 0,
			needTorce: false,
		};
	},
	created() {
		this.getDataStep();
	},
	methods: {
		isAdditionalReady() {
			return this.additional;
		},
		deactivate() {
			this.visabilityInner = !this.visabilityInner;
			this.selectedPanelModel = null;
			this.selectedPanelTorce = 0;
			this.selectedPanelDocking = 0;
			this.selectedPanelColor = null;
			this.needTorce = false;
		},
		setActiveElement(index) {
			if (this.selectedPanelModel !== index) {
				this.selectedPanelColor = null;
			}
			this.selectedPanelModel = index;
		},
		setActiveElement2(index) {
			this.selectedPanelTorce = index;
			this.needTorce = index;
		},
		getDataStep: function () {
			let context = this;
			let req = BX.ajax.runComponentAction(
				'mworks:configurator',
				'getDataAdditional2',
				{
					mode: 'class',
					method: 'post',
					data: {
						position: '',
					},
				}
			);

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.additional = response.data.result;
				}
			});
		},
		changeTorceCount(val) {
			if (!this.needTorce) return (this.torceCount = 0);
			this.torceCount = val;
		},
	},
	mounted() {},
	watch: {
		isAdditionalReady() {
			this.setPropPosition({
				panelTorce: this.additional.torce[this.selectedPanelTorce],
			});
			this.setPropPosition({
				panelDocking: this.additional.docking[this.selectedPanelDocking],
			});
		},
		selectedPanelModel: function (index) {
			this.setPropPosition({ panelModel: this.additional.panels[index] });
		},
		selectedPanelColor: function (index) {
			this.setPropPosition({ panelColor: this.additional.panelsColor[index] });
		},
		selectedPanelTorce: function (index) {
			this.setPropPosition({ panelTorce: this.additional.torce[index] });
		},
		selectedPanelDocking: function (index) {
			this.setPropPosition({ panelDocking: this.additional.docking[index] });
		},
		torceCount(val) {
			this.setPropPosition({ panelTorceCount: Number(val) });
		},
	},
	props: [],
	template: `
<AdditionalRow>
	<AdditionalButton title="Выбрать стеновые панели" v-show="!visabilityInner" :class="{hidden: visabilityInner}"
		v-on:setInnerVisibility="visabilityInner = !visabilityInner" />
	<AdditionalInner v-show="visabilityInner" v-if="isAdditionalReady()">
		<AdditionalButtonHide title="стеновые панели" v-on:setInnerVisibility="deactivate" />

		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Модель панелей</div>
			<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="(slide, index) of additional.panels">
					<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
						:class="{active: selectedPanelModel === index}" v-on:setActive="setActiveElement(index)" />
				</div>
			</Swiper>
		</div>

		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Цвет панелей</div>
			<ConfigBlockColors>
				<Color v-for="(color, index) of additional.panelsColor" :color="color" :key="index"
					v-on:setActiveColor="selectedPanelColor = index" :class="{active: selectedPanelColor===index}" />
			</ConfigBlockColors>
		</div>

		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Торцевой элемент</div>
			<Swiper :basicSlidesPerView="1.6" :basicSpaceBetween="20" :breakpointsForSlides="2">
				<div class="swiper-slide" v-for="(slide, index) of additional.torce">
					<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
						:class="{active: selectedPanelTorce === index}" v-on:setActive="setActiveElement2(index)" />
				</div>
			</Swiper>
		</div>

		<div class="config-block__wrap mt-48" v-show="needTorce">
			<div class="config-block__wrap-title">Количество</div>
			<ConfigBlockRow>
				<Input class="w-100p sm:w-50p" name="count_plinths" placeholder="Укажите количество" label="1 элемент = N см" v-on:changeValue="changeTorceCount" />
			</ConfigBlockRow>
		</div>

		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Стыковочная планка</div>
			<Swiper :basicSlidesPerView="1.6" :basicSpaceBetween="20" :breakpointsForSlides="2">
				<div class="swiper-slide" v-for="(slide, index) of additional.docking">
					<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
						:class="{active: selectedPanelDocking === index}" v-on:setActive="selectedPanelDocking = index" />
				</div>
			</Swiper>
		</div>

	</AdditionalInner>
</AdditionalRow>
`,
});
